import React from "react";
import { darkTheme } from "@yleisradio/yds-core";
import { Pause, Play } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { focusColor } from "../../styles/variables";

const BackgroundVideoPlayButtonStyled = styled.button`
  align-items: center;
  background-color: rgb(0 0 0 / 49%);
  border-radius: 60px;
  border: none;
  color: ${darkTheme.ACTION_PRIMARY};
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  pointer-events: auto;
  position: absolute;
  right: 16px;
  top: 16px;
  width: 40px;

  &:hover {
    background-color: rgb(0 0 0 / 55%) !important;
  }

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

export const BackgroundVideoPlayButton = () => {
  const { useStoreState } = usePlayerStore();
  const isPaused = useStoreState.isPaused();
  const player = useStoreState.player();

  const { language } = useEmbedParametersContext();

  const labelPlayPauseNoShortcutKey = i18n(
    isPaused ? "toista_aria_label" : "keskeyta_aria_label",
    {
      language
    }
  );

  const iconSize = {
    height: 20,
    width: 20
  };

  return (
    <BackgroundVideoPlayButtonStyled
      aria-label={labelPlayPauseNoShortcutKey}
      /** DO NOT change the class name without consulting Yle palvelu/ Ukko. They will use the class name. */
      className="background-video-play-button"
      onClick={() => (isPaused ? player.play() : player.pause())}>
      {isPaused ? <Play {...iconSize} /> : <Pause {...iconSize} />}
    </BackgroundVideoPlayButtonStyled>
  );
};
